/**
 * WebSocketControl - Кнопка управления всеми WebSocket подписками
 * ЗАЧЕМ: Позволяет трейдеру включать/выключать все live подписки одной кнопкой
 * Затрагивает: Все WebSocket подписки (опционы, фьючерсы)
 * 
 * Показывается только когда рынок открыт (market_mode === 'live')
 */

import React from 'react';
import { Play, Pause, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const WebSocketControl = ({ isEnabled, isConnecting, onToggle, marketMode, className = '' }) => {
  // Кнопка показывается только когда потенциально возможен live режим
  // ЗАЧЕМ: Если рынок закрыт (closed) или на перерыве - live данных нет, кнопка бессмысленна
  // РЕЖИМЫ: live (основная сессия), after-hours (после закрытия), pre_open (премаркет)
  const canHaveLiveData = marketMode === 'live' || marketMode === 'after-hours' || marketMode === 'pre_open';
  
  if (!canHaveLiveData) {
    return null;
  }
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isEnabled ? "default" : "outline"}
            size="sm"
            onClick={onToggle}
            disabled={isConnecting}
            className={`flex items-center gap-2 ${className}`}
            style={isEnabled ? { backgroundColor: 'rgb(100, 100, 100)', borderColor: 'rgb(100, 100, 100)' } : {}}
          >
            {isConnecting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                <span className="text-xs font-medium">CONNECTING</span>
                <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" />
              </>
            ) : isEnabled ? (
              <>
                <Pause size={16} />
                <span className="text-xs font-medium">LIVE</span>
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              </>
            ) : (
              <>
                <Play size={16} />
                <span className="text-xs font-medium">PAUSED</span>
                <div className="w-2 h-2 bg-gray-400 rounded-full" />
              </>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">
            {isConnecting 
              ? 'Подключение к WebSocket...'
              : isEnabled 
                ? 'Остановить все live подписки (WebSocket)' 
                : 'Запустить все live подписки (WebSocket)'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default WebSocketControl;
